<template>
  <div>
    <el-upload
      v-loading="loading"
      ref="upload"
      :disabled="cntrldisabled"
      :action="cntrluploadapi"
      :headers="uploadHeaders"
      :list-type="listtype"
      :auto-upload="cntrlautoupload"
      multiple
      :limit="100"
      :file-list="fileList"
      :on-preview="onPreview2"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :on-success="afterUpload"
      :on-remove="handleRemove"
      :accept="acceptonlyimages ? imageonly : '*'"
    >
      <i class="el-icon-plus" v-if="listtype === 'picture-card'"></i>

      <el-button
        slot="trigger"
        size="small"
        type="primary"
        v-if="listtype === 'text' && !cntrldisabled"
      >Faylı əlavə et</el-button>
    </el-upload>
    <div style="text-align: center; width: 100%" v-if="downloadAll && fileList.length > 0">
      <el-button size="small" type="text" @click.native="click" :loading="downloading">
        <i class="el-icon-download"></i>
        {{$t('Hamısını_yüklə')}}
      </el-button>
    </div>

    <el-dialog
      class="custom-dialog"
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :center="true"
      append-to-body
    >
      <upload-preview :selectedIndex="selectedIndex" :images="imageFileList" v-if="dialogVisible" />
    </el-dialog>

    <el-dialog
      class="custom-dialog"
      :visible.sync="dialogVideoVisible"
      :fullscreen="true"
      :center="true"
      append-to-body
      :destroy-on-close="true"
    >
      <upload-video :url="selectedVideo" v-if="dialogVideoVisible" />
    </el-dialog>
  </div>
</template>

<script>
import { GenerateHex } from "../../services/crypto";
import { api, fileurl } from "../../services/helper";
import { Create, GetFiles, Delete } from "../../services/files";
import { FileType } from "../../services/types";
import UploadPreview from "./UploadPreview";
import UploadVideo from "./UploadVideo";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
export default {
  name: "upload",
  computed: {
    cntrluploadapi() {
      return api + "/Upload";
    },
    imageFileList() {
      return this.fileList.filter(c => !this.video.includes(this.getFileExtension(c.urlorig)));
    }
  },
  components: {
    UploadPreview,
    UploadVideo,
  },
  props: {
    sourcetype: Number,
    sourceId: [Number, String],
    uploadapi: {
      type: String,
      default: "/",
    },
    fileurl: { type: String, default: fileurl },
    disabled: { type: Boolean, default: false },
    autoupload: { type: Boolean, default: true },
    listtype: { type: String, default: "picture-card" },
    downloadAll: { type: Boolean, default: false },
    acceptonlyimages: { type: Boolean, default: false },
  },
  data() {
    return {
      imageonly: ".jpg,.jpeg,.png,.mp4,.mkv,.mov,.jfif",
      progress: 0,
      fileList: [],
      loading: false,
      downloading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVideoVisible: false,
      selectedIndex: 0,
      cntrlfileurl: this.fileurl,
      cntrldisabled: this.disabled,
      cntrlautoupload: this.autoupload,
      sid: this.sourceId,
      sdid: this.sourcedetId,
      filecount: 0,
      previewlist: [],
      zip: "",
      count: 0,
      fileURLs: [],
      selectedVideo: "",
      video: ["mp4", "mkv", "mov"],
      videothumb: "https://carep.hu-st.com/_assets/thumb_video.png",
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.state.user.jwt,
      },
    };
  },
  methods: {
    getFileExtension(url) {
      if (!url) return '';
      const urlWithoutQuery = url.split('?')[0];
      const parts = urlWithoutQuery.split('.');
      if (parts.length > 1) {
        return parts.pop().toLowerCase();
      }
      return '';
    },
    submit(sourceId, sourcedetId) {
      this.sid = sourceId;
      this.sdid = sourcedetId;
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      if (!file.id) return;

      Delete(file.id).then((response) => {
        this.loading = false;
        if (response.data) {
          this.getFiles();
        } else {
          this.$message({
            type: "error",
            message: response.data.errors[0],
          });
        }
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm('Ləğv olunsun?', 'Təsdiqləyin', {
        confirmButtonText: 'Bəli',
        cancelButtonText: 'Xeyr',
        type: 'warning',
      });
    },

    onPreview2(file) {
      if (this.listtype === "picture-card") {
        let ext = this.getFileExtension(file.urlorig); 
        if (this.video.includes(ext)) {
          this.selectedVideo = file.urlorig;
          this.dialogVisible = false;
          this.dialogVideoVisible = true; 
        } else {
          this.selectedIndex = this.imageFileList.indexOf(file);
          this.dialogVideoVisible = false;
          this.dialogVisible = true; 
        }
      } else {
        window.open(file.url, "_blank");
      }
    },

    beforeUpload(file) {
      let fname = file.name;
      let key = GenerateHex();
      let newname = key + "_" + fname;
      Object.defineProperty(file, "name", {
        writable: true,
        value: newname,
      });
      this.filecount = this.filecount + 1;
    },

    afterUpload(response, file, fileList) {
      if (!response.dbPath) {
        return;
      }

      var f = new FileType();
      f.filename = file.raw.name;
      f.sourcetype = this.sourcetype;
      f.sourceId = this.sid;

      this.loading = true;

      Create(f).then((response) => {
        this.loading = false;
        if (response.data) {
          this.filecount = this.filecount - 1;
          if (this.filecount === 0) this.getFiles();
        } else {
        }
      }).catch((error) => {
        this.loading = false;
      });
    },

    getFiles() {
      if (!this.cntrlfileurl) return;

      this.loading = true;
      GetFiles(this.sourcetype, this.sid).then((response) => {
        this.fillList(response);
        this.$emit("filesloaded");
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },
    fillList(files) {
      this.fileList = [];
      if (files === undefined) return;
      let ext = "";
      let url = "";
      for (let i = 0; i < files.length; i++) {
        let fname = files[i].fileName.substring(
          files[i].fileName.indexOf("_") + 1
        );

        ext = this.getFileExtension(files[i].url); 
        if (this.video.includes(ext)) url = this.videothumb;
        else
          url = files[i].url;

        this.fileList.push({
          name: fname,
          year: files[i].year,
          month: files[i].month,
          id: files[i].id,
          rawname: files[i].fileName,
          url: url,
          urlorig: files[i].url,
        });
      }
    },

    click() {
      this.downloading = true;
      this.download().then(() => {
        this.downloading = false;
      });
    },

    download() {
      return new Promise((resolve, reject) => {
        let urls = [];
        this.fileURLs = [];
        this.fileList.forEach((element) => {
          urls.push(element.urlorig);
        });

        const zip = new JSZip();
        let count = 0;
        const zipFilename = "cm.zip";
        urls.forEach(async function (url) {
          const urlArr = url.split("/");
          const filename = urlArr[urlArr.length - 1];
          try {
            const file = await JSZipUtils.getBinaryContent(url);
            zip.file(filename, file, {
              binary: true,
            });
            count++;
            if (count === urls.length) {
              zip
                .generateAsync({
                  type: "blob",
                })
                .then(function (content) {
                  saveAs(content, zipFilename);
                  resolve(true);
                });
            }
          } catch (err) {
          }
        });
      });
    },
  },
  mounted() {
    this.uploadHeaders = {
      Authorization: 'Bearer ' + this.$store.state.user.jwt,
    };
    this.getFiles();
  },
  watch: {
    sourceId() {
      this.sid = this.sourceId;
      this.getFiles();
    },
    fileurl() {
      this.cntrlfileurl = this.fileurl;
      this.getFiles();
    },
    uploadapi() {
      if (!this.uploadapi) this.cntrluploadapi = "/";
      this.cntrluploadapi = this.uploadapi;
    },
    autoupload() {
      this.cntrlautoupload = this.autoupload;
    },
    disabled() {
      this.cntrldisabled = this.disabled;
    },
  },
};
</script>

<style lang="scss" scope>
.large-icon-button {
  cursor: pointer;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.large-icon-button i {
  font-size: 30px;
}

.custom-dialog .el-dialog__headerbtn {
  font-size: 2em;
  margin-top: -20px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: red;
  font-weight: bold;
}
</style>